import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// //获取原型对象上的push函数
// const originalPush = Router.prototype.push
// //修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }
const routes = [{
    path: '/pc',
    component: () => import('@/components/index.vue'),
    children:[{
        path: 'chat',
        name: 'pchat',
        component: () => import('@/components/pc/index.vue'),
        props: (route) => ({ appid: route.query.appid })
    }]
},{
    path: '/mobile',
    component: () => import('@/components/index.vue'),
    children:[{
            path: 'chat',
            name: 'mchat',
            component: () => import('@/components/mobile/index.vue'),
        }]
},{
    path: '/satisfaction',
    name: 'satisfaction',
    component: () => import('@/components/common/satisfaction.vue'),
    props: (route) => ({ session_code: route.query.session_code })
},{
    path: '/messageRate',
    name: 'messageRate',
    component: ()=> import('@/components/pc/message/message-elements/rate-element.vue')
},{
    path: '/messageBoard',
    name: 'MessageBoard',
    component: ()=> import('@/components/common/MessageBoard')
},{
    path: '/messageLeaveDouble',
    name: 'messageLeaveDouble',
    component: ()=> import('@/components/common/messageLeaveDouble')
}]
const router = new Router({
    base: '/H5/',
    mode: 'history',
    routes
})
router.beforeEach((to,from,next)=>{
    if(to.query){
        sessionStorage.setItem('query',JSON.stringify(to.query))
    }
    next()
})
export default router